var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18156_48312)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77783 5.27783V14.7223C2.77783 16.103 3.89712 17.2223 5.27783 17.2223H14.7223C16.103 17.2223 17.2223 16.103 17.2223 14.7223V13.6113C17.5596 13.3579 17.7778 12.9544 17.7778 12.5001V10.2778C17.7778 9.82344 17.5596 9.42001 17.2223 9.16662V8.33339C17.2223 6.95268 16.103 5.83339 14.7223 5.83339H13.8889V5.27783C13.8889 3.89712 12.7697 2.77783 11.3889 2.77783H5.27783C3.89712 2.77783 2.77783 3.89712 2.77783 5.27783ZM5.27783 4.4445C4.81759 4.4445 4.4445 4.81759 4.4445 5.27783V5.83339H12.2223V5.27783C12.2223 4.81759 11.8492 4.4445 11.3889 4.4445H5.27783ZM16.1112 10.5556H11.9445V12.2223H16.1112V10.5556ZM15.5556 8.88894V8.33339C15.5556 7.87315 15.1825 7.50005 14.7223 7.50005H4.4445V14.7223C4.4445 15.1825 4.8176 15.5556 5.27783 15.5556H14.7223C15.1825 15.5556 15.5556 15.1825 15.5556 14.7223V13.8889H11.6667C10.8997 13.8889 10.2778 13.2671 10.2778 12.5001V10.2778C10.2778 9.51077 10.8997 8.88894 11.6667 8.88894H15.5556Z",
    fill: "#71869D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18156_48312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayment);
export default __webpack_public_path__ + "static/media/iconPayment.5d22ff993543e97573db31d3ac1b44bc.svg";
export { ForwardRef as ReactComponent };